/**
 * Fix quantity +/- clicks when target is a child node (theme checks event.target.name).
 */
(() => {
  const SELECTOR = '.hdt-product__form-qty .hdt-quantity__button[name="plus"], .hdt-product__form-qty .hdt-quantity__button[name="minus"]';

  document.addEventListener(
    'click',
    (event) => {
      const btn = event.target.closest(SELECTOR);
      if (!btn || btn.classList.contains('disabled')) return;

      const wrap = btn.closest('hdt-quantity-wrapp');
      const input = wrap?.querySelector('input[type="number"]');
      if (!input) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const before = input.value;
      if (btn.name === 'plus') input.stepUp();
      else input.stepDown();

      if (before !== input.value) {
        input.dispatchEvent(
          new CustomEvent('change', {
            bubbles: true,
            detail: { target: input },
          })
        );
      }
    },
    true
  );
})();
